import noPhoto from './noPhoto.webp'

const images = {
  noPhoto,
}

export default images
